import { useContext } from 'react';
import { GlobalContext } from '../../services/context/DataContext';
import { GOOGLE_CONFIG } from '../../config';

export const carouselImageSize = {
  compact: '430x200',
  full: '1400x400'
};

export const useQuickView = () => {
  const { imageSliderState } = useContext(GlobalContext);
  const [, setShowImages] = imageSliderState;

  const openGoogleMap = (cords, address) => {
    const arrangeString = address;
    const searchParams = new URLSearchParams();
    searchParams.append('api', '1');
    searchParams.append('query', arrangeString);
    searchParams.append('query', cords);

    const url = `https://www.google.com/maps/search/?${searchParams.toString()}`;

    window.open(url);
  };

  const getGoogleStreetViewImage = (
    addressCoordinates,
    size = carouselImageSize.compact
  ) => {
    const searchParams = new URLSearchParams();
    searchParams.append('size', size);
    searchParams.append('location', addressCoordinates);
    searchParams.append('key', GOOGLE_CONFIG.GOOGLE_MAP_API_KEY);

    return `${GOOGLE_CONFIG.GOOGLE_STREET_VIEW_API}?${searchParams.toString()}`;
  };

  return {
    getGoogleStreetViewImage,
    setShowImages,
    openGoogleMap
  };
};
